export const FILE = 'file';
export const LICENSE = 'license';
